<div class="container-fluid p-3" *ngIf="data">
  <div >
    <!-- Basic Information Section -->
    <div class="form-section">
      <div class="section-header" (click)="toggleSection('basicInfo')">
        <h3 class="section-title">
          Basic Information
          <i class="pi" [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </h3>
      </div>
      <div class="section-content" *ngIf="expandedSections['basicInfo']">
        <div class="form-grid">
          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md" for="nomenclature">Nomenclature <span class="text-warning">*</span></label>
            <input pInputText id="nomenclature" [value]="nomenclature" readonly />
          </div>
        </div>

        <div class="form-grid mt-3">
          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md" for="platform">For which Platform</label>
            <input pInputText id="platform" [value]="platform" readonly />
          </div>

          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md" for="tenderMode">Mode of Tender</label>
            <input pInputText [value]="modeTender" readonly />
          </div>
        </div>
      </div>
    </div>

    <!-- Equipment & System Section -->
    <div class="form-section">
      <div class="section-header" (click)="toggleSection('equipment')">
        <h3 class="section-title">
          Equipment & System
          <i class="pi" [ngClass]="expandedSections['equipment'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </h3>
      </div>
      <div class="section-content" *ngIf="expandedSections['equipment']">
        <div class="form-grid">
          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">Equipment <span class="text-warning">*</span></label>
            <input pInputText [value]="equipmentName" readonly />
          </div>

          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">System <span class="text-warning">*</span></label>
            <input pInputText [value]="systemName" readonly />
          </div>
        </div>
      </div>
    </div>

    <!-- Quantity Details Section -->
    <div class="form-section">
      <div class="section-header" (click)="toggleSection('quantity')">
        <h3 class="section-title">
          Quantity Details
          <i class="pi" [ngClass]="expandedSections['quantity'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </h3>
      </div>
      <div class="section-content" *ngIf="expandedSections['quantity']">
        <div class="form-grid">
          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">Quantity Required <span class="text-warning">*</span></label>
            <input pInputText [value]="quantityRequired" readonly />
          </div>

          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">Quantity Prototype <span class="text-warning">*</span></label>
            <input pInputText [value]="quantityPrototype" readonly />
          </div>

          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">Quantity Bulk (MoD) <span class="text-warning">*</span></label>
            <input pInputText [value]="quantityBulk" readonly />
          </div>
        </div>
      </div>
    </div>

    <!-- Cost Details Section -->
    <div class="form-section">
      <div class="section-header" (click)="toggleSection('cost')">
        <h3 class="section-title">
          Cost Details
          <i class="pi" [ngClass]="expandedSections['cost'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </h3>
      </div>
      <div class="section-content" *ngIf="expandedSections['cost']">
        <div class="form-grid">
          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">Estimated Total Cost</label>
            <input pInputText [value]="estimatedTotalCost" readonly />
          </div>

          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">Estimated Unit Cost</label>
            <input pInputText [value]="estimatedUnitCost" readonly />
          </div>

          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">LLP Cost</label>
            <input pInputText [value]="llpCost" readonly />
          </div>

          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">POEV Cost</label>
            <input pInputText [value]="poevCost" readonly />
          </div>

          <div class="form-field full-width">
            <label class="bg-primary text-white p-2 rounded-md">Consignee</label>
            <input pInputText [value]="consignee" readonly />
          </div>
        </div>
      </div>
    </div>

    <!-- Detailed Information Section -->
    <div class="form-section">
      <div class="section-header" (click)="toggleSection('detailedInfo')">
        <h3 class="section-title">
          Detailed Information
          <i class="pi" [ngClass]="expandedSections['detailedInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </h3>
      </div>
      <div class="section-content" *ngIf="expandedSections['detailedInfo']">
        <div class="editor-field full-width" [class.readonly-editor]="isEditorDisabled">
          <label class="bg-primary text-white p-2 rounded-md">Brief Description/Technical Details</label>
          <editor [init]="init" [(ngModel)]="technicalDetailsValue" [disabled]="isEditorDisabled"></editor>
        </div>
        <div class="editor-field full-width" [class.readonly-editor]="isEditorDisabled">
          <label class="bg-primary text-white p-2 rounded-md">Justification for mode of tender</label>
          <editor [init]="init" [(ngModel)]="technicalDetailsValue" [disabled]="isEditorDisabled"></editor>
        </div>
        <div class="editor-field full-width" [class.readonly-editor]="isEditorDisabled">
          <label class="bg-primary text-white p-2 rounded-md">Any export potential of the proposed item</label>
          <editor [init]="init" [(ngModel)]="technicalDetailsValue" [disabled]="isEditorDisabled"></editor>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid p-3" *ngIf="!data">
  <div class="alert alert-info">No data available</div>
</div>
